// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wasap {\n  background: green !important;\n  color: white; }\n", "",{"version":3,"sources":["webpack://src/pages/Usuarios/usuarios.scss"],"names":[],"mappings":"AAAA;EACC,4BAA2B;EAC3B,YAAW,EAAA","sourcesContent":[".wasap{\n\tbackground:green !important;\n\tcolor:white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
